import React from 'react';
import PropTypes from 'prop-types';

import { withTheme } from '@material-ui/core/styles';

import SvgIcon from '@material-ui/core/SvgIcon';

const IconDiagnosis = ({ theme, ...otherProps }) => (
  <SvgIcon {...otherProps} viewBox="0 0 43.2304 61.890499">
    <path fill={theme.palette.primary.A400} transform="translate(0 5)" d="m41.765 0h-40.3c-0.80865 0-1.465 0.70508-1.465 1.5749v53.641c0 0.8697 0.65635 1.5748 1.4655 1.5748h40.299c0.8094 0 1.4655-0.7051 1.4655-1.5748v-53.641c0-0.87019-0.656-1.575-1.465-1.575z" />
    <path fill={theme.palette.primary.A100} transform="translate(4.1 8)" d="m0 50.618h36.781v-50.618h-36.781v50.618z" />
    <path fill={theme.palette.common.white} transform="translate(3.2 7)" d="m0 50.618h36.781v-50.618h-36.781v50.618z" />
    <path fill={theme.palette.primary.A100} transform="translate(6 30)" d="m0 0h29.405v2.6667h-29.405v-2.6667z" />
    <path fill={theme.palette.primary.A100} transform="translate(6 37)" d="m0 0h29.405v2.6667h-29.405v-2.6667z" />
    <path fill={theme.palette.primary.A100} transform="translate(6 44)" d="m0 0h14.703v2.6667h-14.703v-2.6667z" />
    <path fill={theme.palette.primary.A100} transform="translate(14.2 0)" d="m14.815 4.6568h-14.815v-3.1326c0-0.84179 0.66397-1.5242 1.483-1.5242h11.849c0.819 0 1.483 0.68241 1.483 1.5242v3.1326z" />
    <path fill={theme.palette.grey[100]} transform="translate(10.8 5)" d="m18.225 0h-14.814l-3.1451 3.2319c-0.56799 0.5837-0.16584 1.5817 0.63757 1.5817h19.829c0.8033 0 1.2056-0.99803 0.6375-1.5816l-3.145-3.232z" />
    <path fill={theme.palette.primary.A100} transform="translate(14.7 12)" d="m13.86 4.458h-4.3372v-4.458h-5.1845v4.458h-4.3378v5.3287h4.3378v4.4577h5.1845v-4.4577h4.3372v-5.3287z" />
  </SvgIcon>
);

IconDiagnosis.propTypes = {
  theme: PropTypes.shape({
    palette: PropTypes.shape({
      primary: PropTypes.shape({
        A100: PropTypes.string.isRequired,
        A400: PropTypes.string.isRequired,
      }).isRequired,
      grey: PropTypes.shape({
        100: PropTypes.string.isRequired,
      }).isRequired,
      common: PropTypes.shape({
        white: PropTypes.string.isRequired,
      }).isRequired,
    }).isRequired,
  }).isRequired,
};

export default withTheme()(IconDiagnosis);



// WEBPACK FOOTER //
// ./src/components/icons/IconDiagnosis.js